"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const axios_1 = require("axios");
const AbstractChatMessageAttachmentService_1 = require("./AbstractChatMessageAttachmentService");
const IChatMessageAttachmentService_1 = require("../IChatMessageAttachmentService");
const ChatMessageAttachmentStatus_1 = require("../ChatMessageAttachmentStatus");
class ChatMessageAttachmentHttpService extends AbstractChatMessageAttachmentService_1.AbstractChatMessageAttachmentService {
    constructor(attachmentStore, chatServiceUrl, tokenProvider = () => "") {
        super(attachmentStore);
        this.IsConnected = true;
        this._chatServiceUrl = chatServiceUrl;
        this._tokenProvider = tokenProvider;
    }
    async InternalUploadAttachment(cm, attachmentName, attachmentBytes, errorCallback = null) {
        await this.UploadAttachmentOverHttpAsync(cm, attachmentName, attachmentBytes);
    }
    async UploadAttachmentOverHttpAsync(cm, attachmentName, attachmentBytes) {
        const postUrl = encodeURI(`${this._chatServiceUrl}/api/v1/chats/${cm.BelongToChatId}/chatMessages/${cm.id}/attachments/${attachmentName}/attachmentContent`);
        this._logger.debug(`Post ${attachmentName} to ${postUrl}, size=${attachmentBytes.size}`);
        const token = this._tokenProvider();
        //axios post
        const cmahs = this;
        await axios_1.default.post(postUrl, attachmentBytes, {
            headers: {
                'Authorization': token,
                'Content-Type': attachmentBytes.type,
            },
            onUploadProgress: async (p) => {
                if (p.lengthComputable) {
                    await cmahs.UpdateAttachmentSendingStatusAsync(attachmentName, ChatMessageAttachmentStatus_1.Status.Sending, p.loaded, p.total);
                    cmahs._logger.debug(`${attachmentName}, uploaded=${p.loaded}, total=${p.total}`);
                }
                else {
                    cmahs._logger.debug(`not computable.`);
                }
            }
        });
        //axios general request
        // const cmahs = this;
        // const response = await axios.request( {
        //   method: "post",
        //   url: postUrl,
        //   headers: {
        //     'Authorization': token,
        //     'Content-Type': attachmentBytes.type,
        //   },
        //   data: attachmentBytes,
        //   onUploadProgress: (p) => {
        //     if (p.lengthComputable) {
        //       cmahs.UpdateAttachmentSendingStatus(attachmentName, Status.Sending, p.loaded, p.total);
        //       cmahs._logger.debug(`${attachmentName}, uploaded=${p.loaded}, total=${p.total}`);
        //     } else {
        //       cmahs._logger.debug(`not computable.`);
        //     }
        //   }
        // });
        //Use fetch
        // const resonpse = await fetch(postUrl, {
        //   method: 'POST',
        //   headers: {
        //     'Authorization': token,
        //     'Content-Type': attachmentBytes.type,
        //   },
        //   body: attachmentBytes,
        // });
        //No progress update using fetch.
        //UpdateAttachmentSendingStatus(attachmentName, Status.Sending, sent, total)
        // if (!resonpse.ok) throw new ChatMessageAttachmentServiceError(`Upload ${attachmentName} failed, statusCode=${resonpse.status}, reason=${resonpse.statusText}.`);
        //Using FormData to upload multipart, but the header from fetch API is cleared by setting "Authorization", so another API is provided for upload.
        // const formData  = new FormData();
        // formData.append(attachmentName, attachmentBytes, attachmentName);
        // const resonpse =  await fetch(postUrl, {
        //   method: 'POST',
        //   headers: {
        //      'Authorization': token,
        //   },
        //   body: formData,
        // });
    }
    async InternalDownloadAttachment(cm, attachmentName, errorCallback) {
        const attachmentUrl = encodeURI(`${this._chatServiceUrl}/api/v1/chats/${cm.BelongToChatId}/chatMessages/${cm.id}/attachments/${attachmentName}/attachmentContent`);
        this._logger.debug(`Getting ${attachmentName} file from ${attachmentUrl}`);
        const token = this._tokenProvider();
        //Use axios to support progress.
        const cmahs = this;
        const response = await axios_1.default.get(attachmentUrl, {
            headers: {
                'Authorization': token,
            },
            responseType: 'blob',
            onDownloadProgress: async (p) => {
                await cmahs.UpdateAttachmentReceivingStatsAsync(attachmentName, p.loaded, p.total);
                cmahs._logger.debug(`${attachmentName}, downloaded=${p.loaded}, total=${p.total}`);
            }
        });
        const newBlob = new Blob([response.data], { type: cm.ContentType });
        //Use fetch but not support progress.
        // const response = await fetch(attachmentUrl, {
        //   method: 'GET',
        //   headers: {
        //     'Authorization': token,
        //   },
        // });
        // if (!response.ok) throw new ChatMessageAttachmentServiceError(`Upload ${attachmentName} failed, statusCode=${response.status}, reason=${response.statusText}.`);
        //const resArrayBuffer = await response.arrayBuffer();
        //const newBlob = new Blob([resArrayBuffer], {type : cm.ContentType});
        await this.SaveAttachmentAsync(attachmentName, newBlob);
    }
    async QueryRemoteAttachmentStatus(cm, attachmentName) {
        const getUrl = encodeURI(`${this._chatServiceUrl}/api/v1/chats/${cm.BelongToChatId}/chatMessages/${cm.id}/attachments/${attachmentName}/status`);
        this._logger.debug(`Getting ${attachmentName} status from ${getUrl}`);
        const token = this._tokenProvider();
        const res = await fetch(getUrl, {
            method: 'GET',
            headers: new Headers({
                'Authorization': token,
            }),
        });
        if (!res.ok)
            throw new IChatMessageAttachmentService_1.ChatMessageAttachmentServiceError(`Query remote attachment=${attachmentName} status failed, code= ${res.status}, reason=${res.statusText}`);
        const statusStr = await res.json();
        const status = statusStr;
        return status;
    }
    IsFileTaskRunning() {
        return false;
    }
}
exports.ChatMessageAttachmentHttpService = ChatMessageAttachmentHttpService;
//# sourceMappingURL=ChatMessageAttachmentHttpService.js.map